<script setup lang="ts">
import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'
import BetStatusButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/BetButton/BetStatusButton.vue'
import PocketIncidents from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/PocketIncidents.vue'
import PocketIncidentsTeamSelectionButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/PocketIncidentsTeamSelectionButton.vue'
</script>

<template>
  <PocketIncidents>
    <template #pocketIncidentButton="{ incidentId, title }">
      <PocketIncidentsTeamSelectionButton
        v-if="incidentId === BasketballIncidentId.Timeout"
        :incidentId
        :title
      />
    </template>
    <template #betButtons>
      <BetStatusButton class="w-full" />
    </template>
  </PocketIncidents>
</template>
